import React from 'react';
import { Icon, Header, Menu, Grid } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

const WarningTile = ({ title, icon, iconSize, t, onClick, id, component, className, warningText }) => {

  const renderJustTitle = () => t(title);

  const renderTitleWithSubTitle = () => (
    <>
      <p style={{margin: 0}}>{t(title)}</p>
      <p style={{margin: 0}}>{t(warningText)}</p>
    </>
  );

  const renderContent = () => {
    return warningText ? renderTitleWithSubTitle() : renderJustTitle();
  }

  return (
    <Menu.Item className={className || 'warningTile'}  color={'orange'} onClick={onClick} style={{ cursor: 'pointer' }}>
      {icon && <Icon name={icon} size={iconSize} className="tileIcon" />}
      <Header id={id} className="tileHeader">
        {renderContent()}
      </Header>
      {component && <div className="tileComponent">{component}</div>}
    </Menu.Item>
  );
}

WarningTile.defaultProps = {
  onClick: () => {},
  iconSize: 'huge'
};

export default withTranslation()(WarningTile);
